import React from 'react';

export const parentContext = React.createContext({
    parent: null,
    setParent: parent => {},
});

export const navigationContext = React.createContext({
    helio: null,
    setHelio: helio => {},
    display : "",
    setDisplay : display => {},
    helioDatas: null,
    setHeliodonDatas : datas => {},
});

export const iOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  export const noHeaderContext = React.createContext(false);